import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockHistory(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 5v3l2.667 2.667M1.667 3v2.667h2.666"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 10.111a6.35 6.35 0 0 0 5.986 4.222c3.506 0 6.347-2.835 6.347-6.333s-2.841-6.333-6.347-6.333a6.35 6.35 0 0 0-5.85 3.87"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockHistory);
export default ForwardRef;
